<template>
  <div>
    <div class="mb-1" style="font-size:0.8rem">{{label}} </div>
    <select class="select-underline" v-model="select" @change="$emit('input', select)">
      <slot/>
    </select>
  </div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'LabelSelect',
  components: {},
  props: ['label', 'value'],
  data: function () {
    return {
      TAG: 'LabelSelect :',
      select: this.value
    }
  },
  computed: {
  }
}
</script>
